import script from "./CookiesCoreMixin.vue?vue&type=script&lang=ts"
export * from "./CookiesCoreMixin.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__